import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import {
  assetIds,
  InputDate,
  RichTextfield,
  ThemedAsset,
} from "nemuru-components";
import React, { useContext } from "react";
import { Controller, useForm } from "react-hook-form";
import { parseStringAmountWithUnitToNumber } from "../../../../../../utils/formaters";
import { ICON_TITLE_HEIGHT } from "../../../../../../config/config";
import { objectTypesConfigToArray } from "../../../../../../utils/objectTypesConfigToArray";
import IconTitle from "../../../../../shared/components/IconTitle";
import MainButton from "../../../../../shared/components/MainButton";
import Text from "../../../../../shared/components/Text";
import {
  ownershipTypesConfig,
  ownershipTypesWithoutOtherConfig,
} from "../../config";
import { ConfigContext } from "../../../../../../contexts/ConfigContext";
import {
  validateKeyboardInputDate,
  validateMinimumRentValueAndReturnMessage,
} from "../../../../../../utils/validations";

export default function AdditionalDataResidenceForm({
  onSubmitForm,
  data,
  disableOthers,
}) {
  const { palette, breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down("xs"));
  const {
    state: { dictionaryValues },
  } = useContext(ConfigContext);
  const { register, getValues, handleSubmit, errors, control, watch } = useForm(
    {
      defaultValues: {
        ownershipType: data?.ownershipType || "",
        entranceDate: data?.entranceDate || null,
      },
      reValidateMode: "onBlur",
    }
  );

  return (
    <>
      <Box className="appear-anim">
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_ID_LOCATION}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId="ADDITIONAL_INFORMATION" />}
          subtitle={<Text tId="HOME_INFO" />}
        />
        <FormControl fullWidth>
          <InputLabel id="ownershipType">
            <Text tId="MY_CURRENT_ADDRESS_IS" />
          </InputLabel>
          <Controller
            name="ownershipType"
            control={control}
            rules={{
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
            }}
            render={(props) => (
              <>
                <Select
                  MenuProps={{
                    MenuListProps: {
                      "aria-label": "Select current address ownership type",
                    },
                  }}
                  onChange={(e) => props.onChange(e.target.value)}
                  value={props.value}
                  error={errors.ownershipType ? true : false}
                >
                  {objectTypesConfigToArray(
                    disableOthers === true
                      ? ownershipTypesWithoutOtherConfig
                      : ownershipTypesConfig
                  ).map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.display}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText style={{ color: palette.error.main }}>
                  {errors.ownershipType?.message}
                </FormHelperText>
              </>
            )}
          />
        </FormControl>
        <InputDate
          allowKeyboardPicking={!isMobile}
          locale={dictionaryValues["DATE_LOCALE"]}
          fullWidth
          variant="inline"
          openTo="year"
          autoOk
          disableFuture={true}
          views={["year", "month"]}
          format="MM/yyyy"
          label={<Text tId="ADDRESS_START_DATE" />}
          id="entranceDate"
          name="entranceDate"
          error={errors.entranceDate ? true : false}
          helperText={errors.entranceDate?.message}
          control={control}
          rules={{
            required: {
              value: true,
              message: <Text tId={"REQUIRED_FIELD"} />,
            },
            validate: {
              validate: (value) =>
                validateKeyboardInputDate({ value, disableFuture: true }),
            },
          }}
        />
        {watch("ownershipType") === ownershipTypesConfig.RENT.value && (
          <RichTextfield
            defaultValue={parseStringAmountWithUnitToNumber(
              data?.homeExpensesAmount
            )}
            allowDecimals
            hideIcon
            unitName={"€"}
            fullWidth
            label={
              <>
                <Text tId={"HOME_EXPENSES_AMOUNT_RENT"} />{" "}
                <Typography variant="caption" color="textPrimary">
                  <Text tId={"YOUR_PART"} />
                </Typography>
              </>
            }
            type="text"
            id="homeExpensesAmount"
            name="homeExpensesAmount"
            InputLabelProps={{ shrink: true }}
            inputProps={{
              ref: register({
                required: {
                  value: true,
                  message: <Text tId={"REQUIRED_FIELD"} />,
                },
                validate: {
                  validate: (value) =>
                    validateMinimumRentValueAndReturnMessage(value),
                },
              }),
            }}
            error={errors.homeExpensesAmount ? true : false}
            helperText={errors.homeExpensesAmount?.message}
          />
        )}
      </Box>
      <Box>
        <MainButton onClick={handleSubmit(() => onSubmitForm(getValues()))} />
      </Box>
    </>
  );
}
